<div>
  <glxy-form-field appearance="outline">
    <glxy-label>{{ 'INBOX.NEW_MESSAGE.SEND_TO' | translate }}</glxy-label>
    <input
      *ngIf="emailChannelSupported()"
      matInput
      placeholder="{{ 'INBOX.NEW_MESSAGE.PHONE_NUMBER_EMAIL_OR_CONTACT_NAME' | translate }}"
      [formControl]="control"
      name="contact"
      (input)="searchChanged()"
      autocomplete="off"
      [matAutocomplete]="auto"
    />
    <input
      *ngIf="!emailChannelSupported()"
      matInput
      placeholder="{{ 'INBOX.NEW_MESSAGE.PHONE_NUMBER_OR_CONTACT_NAME' | translate }}"
      [formControl]="control"
      name="contact"
      (input)="searchChanged()"
      autocomplete="off"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete #auto [displayWith]="displayContact" autoActiveFirstOption class="search-select-autocomplete">
      <mat-option *ngFor="let contact of contacts$ | async" [value]="contact" class="contact-info">
        <span class="glxy-option-text label">
          {{ displayContactInfo(contact).name }}
        </span>
        <br />
        <span class="glxy-option-text description">
          {{ displayContactInfo(contact).phoneAndEmail }}
        </span>
      </mat-option>
    </mat-autocomplete>
    <glxy-error *ngIf="control.hasError('phone')">
      {{ 'INBOX.ERROR.INVALID_PHONE_NUMBER' | translate }}
    </glxy-error>
    <glxy-error *ngIf="control.hasError('invalidInput')">
      {{ 'INBOX.ERROR.INVALID_INPUT' | translate }}
    </glxy-error>
    <glxy-error *ngIf="control.hasError('invalidSelection')">
      {{ 'INBOX.ERROR.REQUIRED_FIELD' | translate }}
    </glxy-error>
  </glxy-form-field>
  <button
    mat-flat-button
    color="primary"
    *ngIf="control.value"
    (click)="openAddContactForm()"
    data-action="clicked-show-add-contact-form"
  >
    <mat-icon style="margin-bottom: 4px">add</mat-icon>
    {{ 'INBOX.NEW_MESSAGE.CREATE_A_NEW_CONTACT' | translate }}
  </button>
</div>
